import { FaqPages, PracticeTestTypeEnum } from '__generatedTypes__/globalTypes'
import {
  CARSBoosterBaseSubject,
  INBDEBoosterBaseSubject,
  NDEBBoosterBaseSubject,
  PATBoosterBaseSubject,
  PlatformSlug,
} from 'constants/consts'
import { DescriptionPages } from 'components/DescriptionForm'
import { cmsRoutes } from 'routes/cmsRoutes'

export enum MockExamsTabs {
  Tests = 'Tests',
  Description = 'Description',
  FAQ = 'FAQ',
}

export const COMMON_PTS_CONFIG: Partial<
  Record<
    PracticeTestTypeEnum,
    {
      type: PracticeTestTypeEnum
      titleSingle: string
      titleMultiple: string
      dashboardLink: string
      createLink: string
      editLink: string
      subjectIds: Partial<Record<PlatformSlug, string>>
      descriptionPage?: DescriptionPages
      faqPage?: FaqPages
      dashboardSettings?: {
        hideAccessColumn?: boolean
        hideLiveColumn?: boolean
        showCurrentlyAccessingColumn?: boolean
      }
    }
  >
> = {
  [PracticeTestTypeEnum.PracticeTest]: {
    type: PracticeTestTypeEnum.PracticeTest,
    titleSingle: 'Practice Test',
    titleMultiple: 'Practice Tests',
    dashboardLink: cmsRoutes.COMMON_PTS,
    createLink: cmsRoutes.COMMON_PTS_CREATE,
    editLink: cmsRoutes.COMMON_PTS_EDIT,
    subjectIds: {
      [PlatformSlug.PATBooster]: PATBoosterBaseSubject,
    },
    /* We reuse DescriptionPages.MockExams for both Mock Exams and Common PTs */
    descriptionPage: DescriptionPages.MockExams,
    /* We reuse FaqPages.MockExam for both Mock Exams and Common PTs */
    faqPage: FaqPages.MockExam,
  },
  [PracticeTestTypeEnum.MockTest]: {
    type: PracticeTestTypeEnum.MockTest,
    titleSingle: 'Platform Mock',
    titleMultiple: 'Platform Mock',
    dashboardLink: cmsRoutes.PLATFORM_MOCK,
    createLink: cmsRoutes.PLATFORM_MOCK_CREATE,
    editLink: cmsRoutes.PLATFORM_MOCK_EDIT,
    subjectIds: {
      [PlatformSlug.INBDEBooster]: INBDEBoosterBaseSubject,
    },
    /* We reuse DescriptionPages.MockExams for both Mock Exams and Common PTs */
    descriptionPage: DescriptionPages.MockExams,
    /* We reuse FaqPages.MockExam for both Mock Exams and Common PTs */
    faqPage: FaqPages.MockExam,
  },
  [PracticeTestTypeEnum.InPersonMockTest]: {
    type: PracticeTestTypeEnum.InPersonMockTest,
    titleSingle: 'In-Person Mock',
    titleMultiple: 'In-Person Mock',
    dashboardLink: cmsRoutes.IN_PERSON_MOCK,
    createLink: cmsRoutes.IN_PERSON_MOCK_CREATE,
    editLink: cmsRoutes.IN_PERSON_MOCK_EDIT,
    subjectIds: {
      [PlatformSlug.INBDEBooster]: INBDEBoosterBaseSubject,
      // Temp hide In-Person Mock for NBDHEBooster, because we don't have Intro screen on web yet:
      // features/PracticeTest/TestFlow/Layout/Body/NBDHE/Body.tsx
      // [PlatformSlug.NBDHEBooster]: NBDHEBoosterBaseSubject,
      [PlatformSlug.NDEBCrusher]: NDEBBoosterBaseSubject,
    },
    dashboardSettings: {
      hideAccessColumn: true,
      hideLiveColumn: true,
      showCurrentlyAccessingColumn: true,
    },
  },
  [PracticeTestTypeEnum.CarsPracticeTest]: {
    type: PracticeTestTypeEnum.CarsPracticeTest,
    titleSingle: 'Practice Test',
    titleMultiple: 'Practice Tests',
    dashboardLink: cmsRoutes.CARS_PTS,
    createLink: cmsRoutes.CARS_PTS_CREATE,
    editLink: cmsRoutes.CARS_PTS_EDIT,
    subjectIds: {
      [PlatformSlug.CARSBooster]: CARSBoosterBaseSubject,
    },
    descriptionPage: DescriptionPages.CarsPracticeTests,
  },
  [PracticeTestTypeEnum.CarsPracticePassage]: {
    type: PracticeTestTypeEnum.CarsPracticePassage,
    titleSingle: 'Practice Passage',
    titleMultiple: 'Practice Passages',
    dashboardLink: cmsRoutes.CARS_PPS,
    createLink: cmsRoutes.CARS_PPS_CREATE,
    editLink: cmsRoutes.CARS_PPS_EDIT,
    subjectIds: {
      [PlatformSlug.CARSBooster]: CARSBoosterBaseSubject,
    },
    descriptionPage: DescriptionPages.CarsPracticePassages,
  },
  [PracticeTestTypeEnum.DailyCarsPractice]: {
    type: PracticeTestTypeEnum.DailyCarsPractice,
    titleSingle: 'Daily CARS',
    titleMultiple: 'Daily CARS',
    dashboardLink: cmsRoutes.DAILY_CARS,
    createLink: cmsRoutes.DAILY_CARS_CREATE,
    editLink: cmsRoutes.DAILY_CARS_EDIT,
    subjectIds: {
      [PlatformSlug.CARSBooster]: CARSBoosterBaseSubject,
    },
    descriptionPage: DescriptionPages.DailyCarsPractice,
    faqPage: FaqPages.DailyCarsPractice,
    dashboardSettings: {
      hideAccessColumn: true,
    },
  },
}
